module.exports = __webpack_public_path__ + "img/p-banner-502.2d0b9711.png";